
import * as React from "react";
import uhaulStore from "../CustomRedux/UhaulStore";
import { Button } from "@twilio/flex-ui";
import { Actions } from "@twilio/flex-ui";
import { supervisorAvailable } from "./Actions/CommonActions";

export class SupervisorTransferChatButton extends React.Component {

    constructor(props) {
        super(props);
    }

    transferToSupervisor = (task) => {
        var environ = uhaulStore.getState().UhaulReducer.config.environment;
        var targetSid = environ === "PROD"
            ? "WQ7c183ee0f0e18f8b0b44dc6e5d990b13"
            : "WQb329fe149754d72df4f41381e17b7d3e";

        supervisorAvailable().then(available => {
            if (!available) {
                alert("No available supervisors at this time. Please try again later.");
            } else if (window.confirm("Are you sure you want to transfer this chat to your supervisor?")) {
                // Transfer the chat
                const chatTransferPayload = { task, targetSid, options: { mode: "COLD" } };
                Actions.invokeAction("ChatTransferTask", chatTransferPayload);
            }
        });
    }

    render() {
        var showButton = this.props.task
                      && this.props.task.taskChannelUniqueName
                      && this.props.task.taskChannelUniqueName === "chat"
                      && this.props.task._task
                      && this.props.task._task.status !== "wrapping"
                      && (this.props.task._task.workflowName == null || this.props.task._task.workflowName.toLowerCase() !== "supervisor-monitor")
                      && (this.props.task._task.attributes == null || this.props.task._task.attributes.isBargedOn == null || !this.props.task._task.attributes.isBargedOn);
        if (showButton) {
            return (
                <div className="transferChat" key="supervisorTransferButton">
                    <br/>
                    <Button variant="primary"
                            onClick={() => this.transferToSupervisor(this.props.task)}>
                        Transfer to Supervisor
                    </Button>
                </div>
            )
        }
        else {
            return null;
        }
    }
}
